import { render, staticRenderFns } from "./LotCreate.vue?vue&type=template&id=981136b4&"
import script from "./LotCreate.vue?vue&type=script&lang=js&"
export * from "./LotCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports